import { z } from "zod";
import { PharmacyProductSchema } from "./product";

export const PharmacyOrderStatusSchema = z.enum([
	"pending",
	"processing",
	"shipped",
	"delivered",
	"cancelled",
	"refunded",
]);

export const DeliveryDetailsSchema = z.object({
	fullName: z.string().min(1, "שם מלא נדרש"),
	phone: z.string().min(1, "טלפון נדרש"),
	address: z.string().min(1, "כתובת נדרשת"),
	city: z.string().min(1, "עיר נדרשת"),
	postalCode: z.string().optional(),
	deliveryNotes: z.string().optional(),
});

export const PharmacyOrderItemSchema = z.object({
	product: PharmacyProductSchema,
	quantity: z.number().int().min(1, "כמות חייבת להיות לפחות 1"),
});

export const PharmacyOrderSchema = z.object({
	id: z.string().min(1),
	userId: z.string().min(1),
	userEmail: z.string().email().or(z.literal("")).optional(),
	items: z.array(PharmacyOrderItemSchema),
	deliveryDetails: DeliveryDetailsSchema,
	total: z.number().min(0, "סכום לא יכול להיות שלילי"),
	originalTotal: z.number().positive().optional(),
	coinsUsed: z.number().min(0).optional(),
	coinsAwarded: z.boolean().optional(),
	// True once the coins the client spent on this order have been given back
	// (on cancel/refund or on delete). Guards against refunding twice when an
	// order is first cancelled and then deleted.
	coinsUsedRefunded: z.boolean().optional(),
	status: PharmacyOrderStatusSchema.default("pending"),
	createdAt: z.number(),
	updatedAt: z.number(),
	// Soft delete. The document is kept — an order that was paid for, shipped or
	// refunded still matters for accounting — but every order list hides it.
	// Written by the deletePharmacyOrder callable; absent on live orders.
	deletedAt: z.number().optional(),
	deletedBy: z.string().optional(),
});

export type TPharmacyOrder = z.infer<typeof PharmacyOrderSchema>;
export type TPharmacyOrderStatus = z.infer<typeof PharmacyOrderStatusSchema>;
export type TDeliveryDetails = z.infer<typeof DeliveryDetailsSchema>;
export type TPharmacyOrderItem = z.infer<typeof PharmacyOrderItemSchema>;

